/**
 * BETA PRIVAT FLAG
 * ----------------
 * Cât timp acest flag e `true`:
 *  - Toate butoanele de upgrade / "Alege planul" plătit sunt dezactivate.
 *  - Se afișează un banner global "BETA PRIVAT — fără plăți active".
 *  - Pagina de selectare plan permite doar planul gratuit.
 *
 * Pentru a activa plățile (după înființarea SRL/PFA și completarea
 * datelor juridice în Terms & Privacy):
 *   1. Schimbă `BETA_MODE` la `false`.
 *   2. Asigură-te că placeholderele [ADRESĂ SEDIU SOCIAL], [XXXXXXXX]
 *      și J[XX/XXXX/XXXX] au fost înlocuite în src/pages/Terms.tsx
 *      și src/pages/Privacy.tsx.
 *   3. Conectează provider-ul de plată (Stripe / Paddle).
 */
export const BETA_MODE = true;

export const BETA_BANNER_TEXT =
  "BETA PRIVAT — plățile sunt dezactivate. Toate funcțiile sunt gratuite în această perioadă.";
